<template>
  <div>
    <b-card-text class="m-3">
      <h3 class="text-center">
        Aviso de Privacidad Simplificado
      </h3>
      <p class="text-justify">
        El Instituto para el Desarrollo Técnico de las Haciendas Públicas (INDETEC), es el sujeto obligado y responsable del tratamiento de los datos personales que se recaban, mismos que serán protegidos conforme a lo dispuesto por la Ley General de Protección de Datos Personales en Posesión de los Sujetos Obligados y demás normatividad que resulte aplicable.
      </p>
      <p class="text-center"><u class="text-center"><b>
        Finalidad del tratamiento de datos personales
      </b></u></p>
      <p class="text-justify">
        Los datos que se recaban se utilizarán para realizar los trámites de contratación de personal, ingresos, pago de nómina, integración del expediente de personal que labora o laboró en INDETEC, generación de credenciales, otorgamiento de prestaciones, trámites de viáticos, pagos de viáticos y pasajes para la atención de encomiendas o realización de comisiones oficiales de los servidores públicos; gestiones y trámites administrativos relacionados con la solicitud de ofertas sobre cotización de bienes y servicios; habilitación del espacio de interacción dentro del portal de acceso restringido para miembros de los diferentes organismos del SNCF; controles de capacitación y/o profesionalización, inscripción, reinscripción, estudio y obtención de Certificados, Diplomas, Títulos y/o constancias de estudio y/o constancias de participación, derivados de los programas educativos de posgrado y/o cursos de capacitación impartidos por INDETEC; la suscripción y ejecución de Convenios de Apoyo y Colaboración Institucional celebrados entre INDETEC y cualquier autoridad, organismo o ente público, sea municipal, estatal y/o federal; trámites administrativos relacionados con pago a proveedores, para llevar a cabo procesos de contratación de bienes y servicios, efectuar pagos a través de transferencia electrónica de pago a proveedores; control de acceso a las instalaciones; alta de beneficiarios en sistemas para la seguridad social; resguardo de los bienes muebles asignados para el desarrollo de sus actividades institucionales; así como el registro de los servidores públicos adscritos a la institución en sistemas institucionales y, en general, para llevar a cabo los procesos que se relacionen con lo anterior y con las funciones de INDETEC establecidas en el artículo 22 de la Ley de Coordinación Fiscal.
      </p>
      <p class="text-justify">
        <b>Datos personales sensibles:</b>
        En su caso, datos de salud para la atención de emergencias médicas (tipo de sangre, padecimientos, alergias) y huella dactilar (dato biométrico) que se recaben, se utilizarán para la integración de expedientes y control de personal; y requerirán el consentimiento expreso y por escrito del titular de los derechos.
      </p>
      <p class="text-justify">
        <b>Uso de Cookies.</b>
        La página de internet
        <a href="www.indetec.gob.mx">www.indetec.gob.mx</a>
        utiliza cookies para ayudar a obtener información que nos permite mejorar su experiencia como usuario y brindarle un mejor servicio. En cualquier momento puede eliminar las cookies accediendo a las preferencias de configuración de su navegador.
      </p>
      <p class="text-center"><u class="text-center"><b>
        Transferencia de datos personales
      </b></u></p>
      <p class="text-justify">
        No se realizarán transferencias de datos personales, salvo aquéllas que sean necesarias para atender el ejercicio de las atribuciones encomendadas o atender requerimientos de información de una autoridad competente que estén debidamente fundadas y motivadas.
      </p>
      <p class="text-center"><u class="text-center"><b>
        Mecanismos y medios disponibles para manifestar su negativa para el tratamiento de datos
      </b></u></p>
      <p class="text-justify">
        El titular de los datos podrá manifestar su negativa para el tratamiento de sus datos personales para finalidades y transferencias de datos personales que requieren el consentimiento del titular, en las oficinas de INDETEC ubicadas en la Calle Paseo del Alba No. 1276, Esquina Con Av. Gral. Ramón Corona, Col. Solares Residencial C.P. 45019,
        Zapopan, Jalisco. México o por medio del correo electrónico
        <a :href="emaiMTra">{{ mailConstructor(1) }}</a>
      </p>
      <p class="text-center"><u class="text-center"><b>
        Consulta del aviso de privacidad integral
      </b></u></p>
      <p class="text-justify">
        El aviso integral de privacidad puede ser consultado a través del sitio
        <a href="https://www.indetec.gob.mx/aviso-privacidad-integral.php">https://www.indetec.gob.mx/aviso-privacidad-integral.php.</a>
        En caso de que exista algún cambio en el aviso de privacidad, lo haremos de su conocimiento a través del mismo sitio.
      </p>
    </b-card-text>
  </div>
</template>

<script>
import {
  BCardText,
} from 'bootstrap-vue'
import { mailConstructor } from '@core/utils/utils'

export default {
  components: {
    BCardText,
  },
  data() {
    return {
      mailConstructor,
      emaiMTra: '',
    }
  },
  created() {
    this.emaiMTra = `mailto:${mailConstructor(1)}`
  },
}
</script>
